<template>
  <div class="products">
    <div v-if="isServicesData">
      <service
        v-for="service in servicesData"
        :key="service.oid"
        :data="service"      
      />
    </div>
    <div class="blankstate" v-else>
      <md-icon>sentiment_very_dissatisfied</md-icon>
      <h1 class="blankstate-title">Siamo spiacenti, non ci sono disponibilità per la data selezionata</h1>
    </div>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'
import service from './service'
export default {
  name: 'servicesList',
  components: {
    service
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters({ 
      products: 'shops/products',
      current: 'shops/current',
      services: 'shops/services',
    }),
    servicesData() {
      return this.services ? this.services : {}
    },
    isServicesData() {
      return this.servicesData.length > 0
    }
  },
  methods: {
    ...mapActions({
      getServices: 'shops/getServices',
    })
  },
  beforeMount() {
    this.getServices()
  },
  mounted() {        
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/modules/common/components/services/servicesList.vue